import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryTabs() {
  const location = useLocation();
  const currentSlug = location.pathname.split("/category/")[1] || "";

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 no-scrollbar">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
          !currentSlug
            ? "bg-rose-500 text-white"
            : "bg-background-100 text-foreground-700 hover:bg-background-200"
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
            currentSlug === cat.slug
              ? "bg-rose-500 text-white"
              : "bg-background-100 text-foreground-700 hover:bg-background-200"
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}